import { Grid } from '@mui/material';
import { Outlet } from 'react-router-dom';
import './pause.styles.scss';

const Pause = () => {
    return (
        <Grid container className='pause-container'>
            <Outlet/>
        </Grid>
    )
}

export default Pause;